import React from "react";
import { palette } from "../palette";

const c = palette.ill;

// Flat-vector spot glyphs drawn in the illustration palette, so the cards feel
// hand-drawn like the hero rather than sprinkled with a UI icon set.
const SHAPES = {
  mentor: (
    <>
      <circle cx="17" cy="15" r="6" fill={c.ink} />
      <path d="M7 34c0-5.5 4.5-10 10-10s10 4.5 10 10z" fill={c.plum} />
      <circle cx="31" cy="19" r="4.5" fill={c.skin[0]} />
      <path d="M24 34c0-4 3.1-7 7-7s7 3 7 7z" fill={c.leaf} />
    </>
  ),
  chat: (
    <>
      <rect x="6" y="8" width="24" height="18" rx="5" fill={c.river} />
      <path d="M12 26l-1 7 8-7z" fill={c.river} />
      <rect x="18" y="18" width="21" height="15" rx="4.5" fill={c.sun} />
    </>
  ),
  roadmap: (
    <>
      <path
        d="M8 33c6-2 4-9 10-11s5-9 11-11"
        fill="none"
        stroke={c.river}
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeDasharray="1 7"
      />
      <circle cx="8" cy="33" r="4.5" fill={c.leaf} />
      <circle cx="31" cy="10" r="5" fill={c.clay} />
    </>
  ),
  content: (
    <>
      <rect x="7" y="7" width="18" height="26" rx="3" fill={c.skyDeep} />
      <rect x="15" y="10" width="19" height="26" rx="3" fill={palette.paper} stroke={c.ink} strokeWidth="2" />
      <rect x="19" y="16" width="11" height="2.6" rx="1.3" fill={c.river} />
      <rect x="19" y="22" width="8" height="2.6" rx="1.3" fill={c.sand} />
    </>
  ),
  project: (
    <>
      <rect x="6" y="13" width="28" height="20" rx="4" fill={c.wood} />
      <rect x="15" y="8" width="10" height="6" rx="2" fill={c.woodDeep} />
      <rect x="6" y="21" width="28" height="3.5" fill={c.woodDeep} />
    </>
  ),
  interview: (
    <>
      <circle cx="14" cy="14" r="7" fill={c.sun} />
      <path d="M4 34c0-5.5 4.5-10 10-10s10 4.5 10 10z" fill={c.clay} />
      <path
        d="M25 12l3.2 6.6 7.3 1-5.3 5.1 1.3 7.2-6.5-3.4-6.5 3.4"
        fill="none"
        stroke={c.plum}
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  launch: (
    <>
      <path d="M20 4c6 5 9 12 9 19l-9 5-9-5c0-7 3-14 9-19z" fill={c.claySoft} />
      <circle cx="20" cy="17" r="4.5" fill={palette.paper} />
      <path d="M13 28l-4 8 7-3zM27 28l4 8-7-3z" fill={c.clay} />
    </>
  ),
  grad: (
    <>
      <path d="M20 8l16 7-16 7-16-7z" fill={c.ink} />
      <path d="M11 20v7c0 3 4 5 9 5s9-2 9-5v-7l-9 4z" fill={c.river} />
      <circle cx="34" cy="20" r="2.6" fill={c.sun} />
    </>
  ),
  student: (
    <>
      <rect x="8" y="10" width="24" height="22" rx="4" fill={c.leaf} />
      <rect x="13" y="6" width="14" height="8" rx="3" fill={c.leafDeep} />
      <rect x="14" y="18" width="12" height="3" rx="1.5" fill={palette.paper} />
    </>
  ),
  switch: (
    <>
      <path
        d="M9 15h18l-5-5M31 25H13l5 5"
        fill="none"
        stroke={c.river}
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="33" cy="12" r="3.4" fill={c.sun} />
    </>
  ),
  pro: (
    <>
      <rect x="6" y="16" width="28" height="17" rx="3.5" fill={c.plum} />
      <path d="M14 16v-4a6 6 0 0112 0v4" fill="none" stroke={c.ink} strokeWidth="3" />
      <rect x="17" y="22" width="6" height="5" rx="1.5" fill={c.sun} />
    </>
  ),
};

export const Spot = ({ kind, size = 44 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    aria-hidden="true"
    focusable="false"
    style={{ display: "block", flexShrink: 0 }}
  >
    {SHAPES[kind] || SHAPES.mentor}
  </svg>
);

export default Spot;
